import * as React from 'react';

import {SectionItem} from 'common/components/items-menu/types';
import {ReportName} from 'common/report/constants';

export type NewReportSectionItem = SectionItem<ReportName>;

export enum TagTheme {
  Neutral = `neutral`,
}

export enum MenuType {
  CreateProjectModal = `createProjectModal`,
}

export type UrlLocation = {
  pathname: string;
  search: string;
  hash: string;
};

export type GlobalSidenavProps = {
  className?: string;
};

export type GlobalSidenavLayoutProps = React.PropsWithChildren;

export enum TrackingEvent {
  ProjectSwitcherOpened = `Project Switcher Opened`,
  NewReportMenuOpened = `New Report Menu Opened`,
  NewReportCreated = `New Report Created`,
  SearchModalOpened = `Search Modal Opened`,
  AppLinkClicked = `App Link Clicked`,
  FooterMenuOpened = `Footer Menu Opened`,
  FooterMenuItemSelected = `Footer Menu Item Selected`,
  ExpansionToggled = `Expansion Toggled`,
  SectionExpansionToggled = `Section Expansion Toggled`,
  Mounted = `Mounted`,
  AgentDropdownOpened = `Agent Dropdown Opened`,
  AgentDropdownBackClicked = `Agent Dropdown Back Clicked`,
  AgentDropdownSubmitted = `Agent Dropdown Submitted`,
}

export enum FooterMenuType {
  Settings = `settings`,
  Help = `help`,
  OverflowApps = `overflow-apps`,
}

export enum FooterMenuItemType {
  /** settings menu */
  Settings = `settings`,
  Language = `language`,
  Appearance = `appearance`,
  ImplementMixpanel = `implement-mixpanel`,
  BillingPlan = `billing-plan`,
  InviteUsers = `invite-users`,
  BackToSignup = `back-to-signup`,
  StartupCreditPromo = `startup-credit-promo`,

  /** help menu */
  Documentation = `documentation`,
  Changelog = `changelog`,
  DemoProjects = `demo-projects`,
  SubmitFeedback = `submit-feedback`,
  LiveChat = `live-chat`,
  ContactSupport = `contact-support`,
  SendbirdAgentChat = `sendbird-agent-chat`,
  ContactSales = `contact-sales`,
  ExternalLink = `external-link`,
}

export type ReportPersistenceCookie = {
  project: number;
  workspace?: number;
  report_path: string;
};
